export default __webpack_public_path__ + "static/media/15901167663720.04f64206.jpg";